import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { RequireAuth } from './auth/RequireAuth';
import TodayScreen from './components/today/TodayScreen';
import LessonRunner from './components/pages/LessonRunner';
import AssessmentRunner from './components/pages/AssessmentRunner';
import SignInPage from './components/pages/SignInPage';
import VerifyPage from './components/pages/VerifyPage';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/sign-in" element={<SignInPage />} />
          <Route path="/auth/verify" element={<VerifyPage />} />
          <Route
            path="/"
            element={
              <RequireAuth>
                <TodayScreen />
              </RequireAuth>
            }
          />
          <Route
            path="/lesson/:lessonId"
            element={
              <RequireAuth>
                <LessonRunner />
              </RequireAuth>
            }
          />
          <Route
            path="/practice"
            element={
              <RequireAuth>
                <LessonRunner mode="practice" />
              </RequireAuth>
            }
          />
          <Route
            path="/assessment/:contextId"
            element={
              <RequireAuth>
                <AssessmentRunner />
              </RequireAuth>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
